import BlockFormatPluginFactory from '../Blocks/BlockFormatPluginFactory';
import CodeBlockComponentPlugin from './CodeBlockComponentPlugin';
import CodeBlockMarkdownPlugin from './CodeBlockMarkdownPlugin';
import CodeBlockPastePlugin from './CodeBlockPastePlugin';
import CodeBlockKeydownHandlerPlugin from './CodeBlockKeydownHandlerPlugin';
import CodeBlockNormalizationsPlugin from './CodeBlockNormalizationsPlugin';
import CodeBlockDecoratorPlugin from './CodeBlockDecoratorPlugin';

export const BlockFormatPlugin = BlockFormatPluginFactory({
  type: 'code',
  title: 'Code block',
  tag: 'pre',
  isMultiline: true,
  allowTab: true,
  matchIndent: true,
  hasCustomComponent: true,
  dependencies: [CodeBlockComponentPlugin],
});

const CodeBlockPlugin = [
  BlockFormatPlugin,
  CodeBlockDecoratorPlugin,
  CodeBlockComponentPlugin,
  CodeBlockMarkdownPlugin,
  CodeBlockPastePlugin,
  CodeBlockKeydownHandlerPlugin,
  ...CodeBlockNormalizationsPlugin,
];

export default CodeBlockPlugin;
